import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NumberFilterModel } from 'ag-grid-community';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { IDateComp, IDateParams } from '@ag-grid-community/core';
import { Calendar, CalendarModule } from 'primeng/calendar';
import * as moment from 'moment';

@Component({
  standalone: true,
  imports: [FormsModule, CommonModule, BsDatepickerModule, CalendarModule],
  template: `
    <div class="ag-filter-wrapper">
      <div class="ag-floating-filter-input">
        <p-calendar
          #calendar
          [placeholder]="'YYYY-MM-DD'"
          [dateFormat]="'yy-mm-dd'"
          [firstDayOfWeek]="1"
          [inputStyleClass]="'form-control custom-placeholder'"
          [appendTo]="'body'"
          [(ngModel)]="currentValue"
          [hideOnDateTimeSelect]="true"
          [maxDate]="maxDate"
          (onSelect)="valueChanged($event)"
          (onInput)="handleDateInput($event)"
          (onShow)="onCalendarShow()"
        />
      </div>
    </div>
  `,
  styles: [
    `
      input[type='text']::-webkit-clear-button {
        display: none;
      }
    `,
  ],
})
export class CustomGridDateFilterComponent implements IDateComp {
  private params!: IDateParams;
  eGui!: HTMLDivElement;
  maxValue!: number;
  currentValue = '';
  selectArray!: any;
  selectTitle = '';
  date: any;
  defaultDate: Date;
  config: any = {
    dateInputFormat: 'YYYY-MM-DD',
    showWeekNumbers: false,
  };
  maxDate: Date;

  @ViewChild('calendar') calendar: Calendar;

  agInit(params: any): void {
    this.params = params;
    this.maxDate = params.filterParams.maxDate as Date;
    this.currentValue = '';
  }

  getGui() {
    return this.eGui;
  }

  valueChanged(event: Date) {
    this.date = this.currentValue === '' ? '' : this.currentValue;
    // @todo need think we need setParentDatePickerString function or not
    // this.setParentDatePickerString();
    this.params.onDateChanged();
  }

  private setParentDatePickerString() {
    const elementParent = document.querySelector('div[ref="eDateWrapper"]');
    const pCalendar = elementParent!.querySelector('p-calendar');
    const pCalendarInput = elementParent!.querySelector('input');
    pCalendarInput!.value = moment(this.date).format('YYYY-MM-DD');
    const elementNested = document.querySelector('div[ref="eBody"]');
  }

  valueChanged2(event: Date) {
    this.date = event;
    this.currentValue = event ? moment(event).format('YYYY-MM-DD') : '';
    if (this.params && this.params.onDateChanged) {
      this.params.onDateChanged();
    }
  }

  handleDateInput(event: any) {
    const date = moment(event.target.value, 'YYYY-MM-DD', true);
    if (!date.isValid()) {
      this.date = null;
      this.currentValue = '';
      this.params.onDateChanged();
      this.calendar?.hideOverlay();
      return;
    }
    this.date = date.toDate();
    this.currentValue = this.date;
    this.setParentDatePickerString();
    this.params.onDateChanged();
    this.calendar?.hideOverlay();
  }

  handleDateInput2(event: any) {
    const date = moment(event.target.value, 'YYYY-MM-DD', true);
    if (!date.isValid()) {
      this.date = null;
      this.currentValue = '';
      if (this.params && this.params.onDateChanged) {
        this.params.onDateChanged();
      }
      return;
    }
    this.date = date.toDate();
    this.currentValue = date.format('YYYY-MM-DD');
    if (this.params && this.params.onDateChanged) {
      this.params.onDateChanged();
    }
  }

  getDate() {
    return this.date;
  }

  setDate(date: any) {
    // this.picker.setDate(date);
    this.date = date;
    this.currentValue = date;
  }

  onParentModelChanged(parentModel: NumberFilterModel): void {
    if (!parentModel) {
      this.currentValue = '';
    } else {
      //@todo need implement else case
      // note that the filter could be anything here, but our purposes we're assuming a greater than filter only,
      // so just read off the value and use that
      //  this.currentValue = parentModel.filter!;
    }
  }

  onCalendarShow(): void {
    // Add event listeners to prevent ag-grid filter popup from closing
    setTimeout(() => {
      const calendarPanel = document.querySelector(
        '.p-datepicker',
      ) as HTMLElement;
      if (calendarPanel) {
        this.addEventListeners(calendarPanel);
      }
    }, 0);
  }

  private addEventListeners(calendarPanel: HTMLElement): void {
    // Only prevent mousedown events from bubbling to ag-grid
    // This prevents the filter from closing while allowing calendar interactions
    const preventFilterClose = (event: MouseEvent) => {
      // Only stop propagation, don't prevent default behavior
      event.stopPropagation();
    };

    // Only add mousedown listener to prevent ag-grid filter from closing
    // Don't interfere with click events which are needed for calendar functionality
    calendarPanel.addEventListener('mousedown', preventFilterClose, true);
  }
}
